import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  return (
    <EducationModuleLayout
      progressStage={5}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-blue no-bold no-margin">
                3. Explain
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                When referring someone it’s helpful to prepare them on what to expect from the resource
                or services being offered and, to connect them with their preferred options.
                This can make it feel less intimidating and may increase the likelihood that they will
                follow through on your referral.  You could draw upon your knowledge and/or research
                and say something like <span style={{ fontStyle: 'italic' }}>“I just learned about
                accessing mental health supports at the campus health center. They can help navigate care
                options as well. I understand that you can call them. Would you like to do this together?”</span>
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER_F} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferE = connect.role(ReferPage);

export default ReferE;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferE/index.jsx